import { useTranslation } from '@frontend/i18n';
import { useInsuranceTabShallowStore } from '@frontend/insurance-tab';
import { Button } from '@frontend/design-system';
import { ScheduleInsuranceTabTrackingIds } from './trackingIds';

export const ResetButton = () => {
  const { t } = useTranslation('scheduleCalendarActions');
  const { setCurrentStatusSelection, setCurrentFilterValue } = useInsuranceTabShallowStore(
    'setCurrentFilterValue',
    'setCurrentStatusSelection'
  );

  const resetFilters = () => {
    setCurrentFilterValue('');
    setCurrentStatusSelection('');
  };

  return (
    <Button
      trackingId={ScheduleInsuranceTabTrackingIds.resetButton}
      onClick={resetFilters}
      size='large'
      variant='tertiary'
    >
      {t('Reset')}
    </Button>
  );
};
